document.addEventListener("click", function (e) {

  /* =========================
     ACCORDION CLICK
  ========================== */

  const header = e.target.closest(".accordion-header");

  if (header) {
    console.log("CLICK WORKING");

    const accordion = header.closest(".accordion");
    const item = header.closest(".accordion-item");

    if (!accordion || !item) return;

    const isActive = item.classList.contains("active");

    // Remove active from siblings ONLY
    accordion.querySelectorAll(".accordion-item").forEach(i => {
      i.classList.remove("active");
    });

    // Re-add if it was closed
    if (!isActive) {
      item.classList.add("active");
    }
  }


  /* =========================
     SHOW MORE BUTTON
  ========================== */

  const btn = e.target.closest(".faq-show-more");

  if (btn) {
    const wrapper = btn.closest(".accordion");

    if (!wrapper) return;

    const hiddenFaqs = wrapper.querySelectorAll(".hidden-faq");

    hiddenFaqs.forEach(item => {
      item.style.display = "block";
    });

    btn.style.display = "none";
  }

});